"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findMatchingDeviceByGroupId = void 0;
const findMatchingDeviceByGroupId = (mediaDevices, kind, currentDeviceGroupId) => {
    return ((mediaDevices === null || mediaDevices === void 0 ? void 0 : mediaDevices.find(device => device.kind === kind && device.groupId === currentDeviceGroupId)) || null);
};
exports.findMatchingDeviceByGroupId = findMatchingDeviceByGroupId;
//# sourceMappingURL=find_matching_device_by_group_id.js.map